import store from '../store/store'

export const hasFeature = (feature) => {
  return (to, from, next) => {
    // if user didn't pass any permissions
    if (!feature) {
      return next('/')
    }

    // reserved keyword to show section to anybody
    if (feature === 'all') {
      return next()
    }

    // get current account
    const activeAccount = store.getters['authentication/activeAccount']

    // eslint-disable-next-line no-extra-boolean-cast
    if (!activeAccount.features) {
      return next('/')
    }

    if (activeAccount.features.indexOf(feature) === -1) {
      return next('/')
    }

    return next()
  }
}
